import React, { useEffect, useRef } from "react";

interface TrixEditorProps {
    value: string;
    onChange: (value: string) => void;
}

export const TrixEditor: React.FC<TrixEditorProps> = ({ value, onChange }) => {
    const editorRef = useRef<HTMLDivElement>(null);
    const contentId = useRef(
        `trix-content-${Math.random().toString(36).substring(2, 11)}`,
    );

    useEffect(() => {
        if (typeof window !== "undefined") {
            import("trix").then(() => {
                const handleChange = () => {
                    const editorElement = editorRef.current?.querySelector(
                        "trix-editor",
                    ) as HTMLElement;
                    const htmlContent = editorElement.innerHTML;
                    onChange(htmlContent);
                };

                const editorElement =
                    editorRef.current?.querySelector("trix-editor");

                editorElement?.addEventListener("trix-change", handleChange);

                return () => {
                    editorElement?.removeEventListener(
                        "trix-change",
                        handleChange,
                    );
                };
            });
        }
    }, [onChange]);

    useEffect(() => {
        if (typeof window !== "undefined" && editorRef.current) {
            const editorElement = editorRef.current.querySelector(
                "trix-editor",
            ) as any;

            try {
                if (
                    editorElement?.editor &&
                    typeof editorElement.editor.getHTML === "function"
                ) {
                    const currentHtml = editorElement.editor.getHTML() || "";
                    if (value !== currentHtml) {
                        editorElement.editor.loadHTML(value || "");
                    }
                }
            } catch (err) {
                console.error("Trix editor error:", err);
                setTimeout(() => {
                    try {
                        if (
                            editorElement?.editor &&
                            typeof editorElement.editor.getHTML === "function"
                        ) {
                            editorElement.editor.loadHTML(value || "");
                        }
                    } catch (e) {
                        console.error("Trix editor error:", e);
                    }
                }, 100);
            }
        }
    }, [value]);

    return (
        <div ref={editorRef} className="trix-editor-container">
            <input id={contentId.current} type="hidden" value={value} />
            <trix-editor input={contentId.current}></trix-editor>
        </div>
    );
};
